// @flow
import React, { Component } from 'react'
import styled, { type StyledComponent } from 'styled-components'

const StyledInput: StyledComponent<Object, any, any> = styled.input`
  width: 100%;
`

type Props = {|
  isLoading: boolean,
  value: string,
  onBlur: Function
|}

type State = {|
  value: string
|}

export default class TemplateInput extends Component<Props, State> {
  constructor(props: Props) {
    super(props)

    this.state = {
      value: props.value
    }
  }

  render() {
    const { isLoading } = this.props
    const { value } = this.state
    return (
      <StyledInput
        type="text"
        className="input-item"
        value={value}
        disabled={isLoading}
        onChange={(e) => this.setState({ value: e.target.value })}
        onBlur={() => this.props.onBlur(value)}
      />
    )
  }
}
